<template>
	<div v-if="assetTypeForm" class="py-8">
		<AssetTypePropertiesForm :form="assetTypeForm" @on-save="saveAssetType" @on-delete="confirmDelete"/>
	</div>
</template>

<script>
import AssetTypePropertiesForm from "@/Forms/AssetType/AssetTypePropertiesForm.vue";
import { mapStores } from "pinia";
import { useAssetTypesStore } from "@/stores/assetTypes.js";

export default {
	name: "AssetTypePropertiesView",
	components: {AssetTypePropertiesForm},
	data() {
		return {
			assetTypeForm: undefined,
		}
	},
	emits: [
		'on-save',
		'on-delete',
	],
	computed: {
		...mapStores(useAssetTypesStore)
	},
	methods: {
		async saveAssetType() {
			console.log('saving asset type');
			try {
				const response = await this.assetTypeForm.submit();
        this.$toast.add({
          severity: 'success',
          summary: this.$t('common.complete'),
          detail: this.$t('pages.admin.assets.asset_types.asset_type.properties.asset_type_properties_view.asset_type_saved'),
          life: 3000
        });
				this.$emit('on-save');
				this.$router.replace({params: {...this.$route.params, type: response.data.id}});
			} catch (error) {
				//
			}
		},
		confirmDelete() {
			this.$confirm.require({
				group: 'delete',
        message: this.$t('pages.admin.assets.asset_types.asset_type.properties.asset_type_properties_view.are_you_sure_you_want_to_delete_this_asset_type'),
        header: this.$t('pages.admin.assets.asset_types.asset_type.properties.asset_type_properties_view.delete_asset_type'),
				accept: () => {
					this.deleteAssetType();
				},
				reject: () => {
					this.$toast.add({
            severity: 'info',
            summary: this.$t('common.cancelled'),
            detail: this.$t('pages.admin.assets.asset_types.asset_type.properties.asset_type_properties_view.asset_type_was_not_deleted'),
            life: 3000
          });
				}
			});
		},
		async deleteAssetType() {
			try {
				if (this.$route.params.type !== 'NEW') {
					await this.assetTypesStore.deleteAssetType(this.$route.params.type);
					this.$emit('on-delete');
				}
				this.$router.push({name: 'admin.assets.types', params: {...this.$route.params, type: undefined}});
			} catch (error) {
				console.log(error);
			}
		},
	},
	watch: {
		'$route.params.type': {
			async handler(newValue, oldValue) {
				if (newValue) {
					if (this.$route.params.type === 'NEW') {
						this.assetTypeForm = await this.assetTypesStore.createAssetType();
					} else {
						this.assetTypeForm = await this.assetTypesStore.editAssetType(this.$route.params.type);
					}
				} else {
					this.assetTypeForm = undefined;
				}
			},
			immediate: true,
		}
	},
}
</script>

<style scoped>

</style>
